const PRODUCT_LOB = {
    RC: 'RETAIL_CARD',
    PSCC: 'PAYMENT_SOLUTIONS_CARECREDIT',
    SETPAY: 'SETPAY'
};
export default PRODUCT_LOB;
